export default __webpack_public_path__ + "static/media/transfacil_galery_1.20abb5a2.jpg";